// import { useContext } from 'react';
// import PastActualsOne from './PastActualsOne';
// import { AppContext } from '../../contexts/AppContext';

// export default function DynamicTableRow({ icons, rowData, title, toggleIcons, monthlyValues = [], weeklyValues = [], forecastValues = [], projectionValues = [] }) {
//   const { PastActualsOneValue, PastActualsTwoValue, PastForecastOneValue, PastForecastTwoValue } = useContext(AppContext);
//   // console.log("printing the values", "monthly", monthlyValues, "weekly", weeklyValues, "forecast", forecastValues, "projection", projectionValues)
//   return (
//     <>
//       <td className="columfix fixed-left style_icons " title={title}>
//         {icons && <span className='_icons' onClick={toggleIcons}>{icons}</span>} {rowData}
//       </td>

//       {/* 1. last‐year months */}
//       {PastActualsOneValue && (
//         <PastActualsOne
//           values={monthlyValues}
//           className="past_actuals"
//         />
//       )}

//       {/* 2. this‐year past weeks */}
//       {PastActualsTwoValue && (
//         <PastActualsOne
//           values={weeklyValues}
//           className="past_actuals_2"
//         />
//       )}

//       {/* 3. “past forecast” (now+2m) */}
//       {PastForecastOneValue && (
//         <PastActualsOne
//           values={forecastValues}
//           className="past_actuals_3"
//         />
//       )}

//       {/* 4. “projected” (2m+4m) */}
//       {PastForecastTwoValue && (
//         <PastActualsOne
//           values={projectionValues}
//           className="projected"
//         />
//       )}
//     </>
//   );
// }


// // src/components/table/DynamicTableRow.jsx
// import React, { useContext } from 'react';
// import PastActualsOne from './PastActualsOne';
// import { AppContext } from '../../contexts/AppContext';

// function normalizeKeyCandidates(rowData, inputName) {
//   const candidates = [];
//   if (inputName) candidates.push(String(inputName));
//   if (rowData) {
//     const s = String(rowData).trim();
//     candidates.push(s);
//     candidates.push(s.toLowerCase());
//     candidates.push(s.replace(/\s+/g, '_').toLowerCase());
//     candidates.push(s.replace(/\W+/g, '_').toLowerCase());
//   }
//   return candidates.filter(Boolean);
// }

// function findMonthlyArrayInAgg(aggObj, candidates) {
//   if (!aggObj) return null;
//   const sections = ['input', 'kpis', 'drivers',
//     'stock', 'stocks', 'stocks_monthly', 'stock_monthly',
//     'forecast_tertiary', 'forecasted_tertiary', 'forecast_tert', 'forecast_tertiary_monthly',
//     'exposure', 'inputs'];
//   // also try top-level array if provided
//   for (const sec of sections) {
//     const arr = aggObj[sec];
//     if (!Array.isArray(arr)) continue;
//     for (const c of candidates) {
//       const found = arr.find(it => String(it.input_name).toLowerCase() === String(c).toLowerCase());
//       if (found && Array.isArray(found.val)) return found.val;
//     }
//   }
//   // fallback: if aggObj is itself array of named arrays
//   if (Array.isArray(aggObj)) {
//     for (const c of candidates) {
//       const found = aggObj.find(it => String(it.input_name).toLowerCase() === String(c).toLowerCase());
//       if (found && Array.isArray(found.val)) return found.val;
//     }
//   }
//   return null;
// }

// export default function DynamicTableRow({
//   icons, rowData, title, toggleIcons,
//   monthlyValues = [], weeklyValues = [], forecastValues = [], projectionValues = [],
//   // NEW optional props (passed from parent)
//   lastWeekIndexToMonthIdx = {}, monthsMeta = [],
//   pastActualsMonthlyAggregation = {}, pastForecastMonthlyAggregation = {}, projectedMonthlyAggregation = {},
//   inputName, pastActualsCount, forecastCount, projectionCount // optional for inputs rows,
// }) {
//   const { PastActualsOneValue, PastActualsTwoValue, PastForecastOneValue, PastForecastTwoValue } = useContext(AppContext);
//   console.log("title", title)

//   // helper to render weekly cells and insert monthly aggregated cell immediately after last week of month
//   const renderWeekCellsWithMonthInsert = (valuesArr = [], section, baseGlobalIndex = 0) => {
//     const cells = [];
//     const candidates = normalizeKeyCandidates(title, inputName);
//     // console.log("candidates", candidates, rowData)

//     // pick aggregation object depending on section
//     let aggObj = null;
//     if (section === 'pastActuals' || section === 'past_actuals') aggObj = pastActualsMonthlyAggregation;
//     else if (section === 'pastForecast' || section === 'past_forecast') aggObj = pastForecastMonthlyAggregation;
//     else if (section === 'projected') aggObj = projectedMonthlyAggregation;

//     // find monthly values array for this row (if any)
//     const monthlyVals = findMonthlyArrayInAgg(aggObj, candidates); // array aligned with monthsMeta
//     // console.log("monthlyVals", monthlyVals, aggObj, section, candidates)
//     for (let i = 0; i < (valuesArr?.length || 0); i++) {
//       const v = valuesArr[i];
//       // normal weekly cell
//       const cellClass = section === 'pastActuals' ? 'past_actuals_2' : (section === 'pastForecast' ? 'past_actuals_3' : 'projected');
//       cells.push(
//         <td key={`wk-${section}-${i}`} className={cellClass}>
//           {v === 0 ? '-' : (v == null ? '-' : (typeof v === 'number' ? v.toLocaleString('en-IN') : v))}
//         </td>
//       );

//       // compute global index for this week-column (0-based)
//       const globalIdx = baseGlobalIndex + i;

//       // get month index if this global index is last week-of-month
//       const monthIdxRaw = lastWeekIndexToMonthIdx != null ? lastWeekIndexToMonthIdx[String(globalIdx)] : undefined;
//       const monthIdx = (monthIdxRaw === undefined) ? null : monthIdxRaw;

//       if (monthIdx !== null && monthIdx !== undefined) {
//         // monthly aggregated value for this row at that month index
//         const mVal = monthlyVals ? monthlyVals[monthIdx] : null;
//         cells.push(
//           <td key={`mon-${section}-${globalIdx}`} className={`${cellClass} monthly-agg`}>
//             {mVal == null ? '-' : (typeof mVal === 'number' ? mVal.toLocaleString('en-IN') : mVal)}
//           </td>
//         );
//       }
//     }

//     return cells;
//   };


//   return (
//     <>
//       <td className="columfix fixed-left style_icons " title={title}>
//         {icons && <span className='_icons' onClick={toggleIcons}>{icons}</span>} {rowData}
//       </td>

//       {/* 1. last-year months (leave as is) */}
//       {PastActualsOneValue && (
//         <PastActualsOne
//           values={monthlyValues}
//           className="past_actuals"
//         />
//       )}

//       {/* 2. this-year past weeks — render weeks + month-aggregate cells */}
//       {PastActualsTwoValue && (
//         <>
//           {renderWeekCellsWithMonthInsert(weeklyValues, 'pastActuals', 0)}
//         </>
//       )}

//       {/* 3. past forecast weeks */}
//       {PastForecastOneValue && (
//         <>
//           {renderWeekCellsWithMonthInsert(forecastValues, 'pastForecast', pastActualsCount || 0)}
//         </>
//       )}

//       {/* 4. projected weeks */}
//       {PastForecastTwoValue && (
//         <>
//           {renderWeekCellsWithMonthInsert(projectionValues, 'projected', (pastActualsCount || 0) + (forecastCount || 0))}
//         </>
//       )}

//     </>
//   );
// }

// correct
// correct
// import React, { useContext, useEffect } from 'react';
// import PastActualsOne from './PastActualsOne';
// import { AppContext } from '../../contexts/AppContext';
// import { EditContext } from '../RightCompoent';

// function normalizeKeyCandidates(rowData, inputName) {
//   const candidates = [];
//   if (inputName) candidates.push(String(inputName));
//   if (rowData) {
//     const s = String(rowData).trim();
//     candidates.push(s);
//     candidates.push(s.toLowerCase());
//     candidates.push(s.replace(/\s+/g, '_').toLowerCase());
//     candidates.push(s.replace(/\W+/g, '_').toLowerCase());
//   }
//   return candidates.filter(Boolean);
// }

// function findMonthlyArrayInAgg(aggObj, candidates) {
//   if (!aggObj) return null;
//   const sections = ['input', 'kpis', 'drivers',
//     'stock', 'stocks', 'stocks_monthly', 'stock_monthly',
//     'forecast_tertiary', 'forecasted_tertiary', 'forecast_tert', 'forecast_tertiary_monthly',
//     'exposure', 'inputs'];
//   // also try top-level array if provided
//   for (const sec of sections) {
//     const arr = aggObj[sec];
//     if (!Array.isArray(arr)) continue;
//     for (const c of candidates) {
//       const found = arr.find(it => String(it.input_name).toLowerCase() === String(c).toLowerCase());
//       if (found && Array.isArray(found.val)) return found.val;
//     }
//   }
//   // fallback: if aggObj is itself array of named arrays
//   if (Array.isArray(aggObj)) {
//     for (const c of candidates) {
//       const found = aggObj.find(it => String(it.input_name).toLowerCase() === String(c).toLowerCase());
//       if (found && Array.isArray(found.val)) return found.val;
//     }
//   }
//   // fuzzy contains fallback
//   for (const sec of sections) {
//     const arr = aggObj[sec];
//     if (!Array.isArray(arr)) continue;
//     for (const it of arr) {
//       if (!it || !it.input_name) continue;
//       for (const c of candidates) {
//         if (String(it.input_name).toLowerCase().includes(String(c).toLowerCase()) ||
//           String(c).toLowerCase().includes(String(it.input_name).toLowerCase())) {
//           if (Array.isArray(it.val)) return it.val;
//         }
//       }
//     }
//   }
//   return null;
// }

// export default function DynamicTableRow({
//   icons, rowData, title, title2, toggleIcons,
//   monthlyValues = [], weeklyValues = [], forecastValues = [], projectionValues = [],
//   // legacy single-section props (kept for compatibility)
//   lastWeekIndexToMonthIdx = {}, monthsMeta = [],
//   // new per-section props (preferred)
//   lastWeekIndexToMonthIdxBySection = {},
//   monthsMetaBySection = {},
//   pastActualsMonthlyAggregation = {}, pastForecastMonthlyAggregation = {}, projectedMonthlyAggregation = {},
//   inputName, pastActualsCount, forecastCount, projectionCount // optional for inputs rows,
// }) {
//   const { PastActualsOneValue, PastActualsTwoValue, PastForecastOneValue, PastForecastTwoValue } = useContext(AppContext);
//   const editCtx = useContext(EditContext) || {};
//   const { projectedMonthlyAggregationEdited } = editCtx;
//   console.log("this ", projectedMonthlyAggregation);
//   console.log("this way", editCtx, projectedMonthlyAggregationEdited);
//   // console.log("title: ", title, title2)

//   useEffect(() => {
//     console.log("projectedMonthlyAggregationEdited", projectedMonthlyAggregationEdited);
//   }, [projectedMonthlyAggregationEdited])

//   const projectedMonthlyAggregationFinal = projectedMonthlyAggregationEdited &&
//     Object.keys(projectedMonthlyAggregationEdited).length > 0
//     ? projectedMonthlyAggregationEdited
//     : projectedMonthlyAggregation;

//   console.log("bool", Object.keys(projectedMonthlyAggregationEdited).length > 0);
//   // helper to look up month idx for a global week index using section-specific map with fallbacks
//   const getMonthIdxForGlobalWeek = (sectionKey, globalIdx) => {
//     if (globalIdx == null) return undefined;

//     const canonical =
//       sectionKey === 'pastActuals' || String(sectionKey).toLowerCase().includes('actual') ? 'pastActuals' :
//         sectionKey === 'pastForecast' || String(sectionKey).toLowerCase().includes('forecast') ? 'pastForecast' :
//           'projected';
//     // console.log("canonical", canonical, lastWeekIndexToMonthIdxBySection, lastWeekIndexToMonthIdxBySection[canonical])

//     const sectionMap = lastWeekIndexToMonthIdxBySection && lastWeekIndexToMonthIdxBySection[canonical];
//     if (sectionMap) {
//       if (typeof sectionMap.get === 'function') return sectionMap.get(globalIdx);
//       return sectionMap[String(globalIdx)];
//     }

//     // fallback to legacy single map
//     if (!lastWeekIndexToMonthIdx) return undefined;
//     if (typeof lastWeekIndexToMonthIdx.get === 'function') return lastWeekIndexToMonthIdx.get(globalIdx);
//     return lastWeekIndexToMonthIdx[String(globalIdx)];
//   };

//   // helper to render weekly cells and insert monthly aggregated cell immediately after last week of month
//   const renderWeekCellsWithMonthInsert = (valuesArr = [], section, baseGlobalIndex = 0) => {
//     const cells = [];
//     // Use title first for matching (keeps previous behaviour),
//     // but include inputName as a candidate too
//     let candidates;
//     if ((section === 'pastForecast' || section === 'projected') && title2) {
//       if (section === 'pastForecast' && rowData === "Opening Retailer Stk") candidates = normalizeKeyCandidates("opening_ret_stk", inputName);
//       else
//         candidates = normalizeKeyCandidates(title2, inputName);
//     } else {
//       candidates = normalizeKeyCandidates(title, inputName);
//     }

//     // pick aggregation object depending on section
//     let aggObj = null;
//     if (section === 'pastActuals' || section === 'past_actuals') aggObj = pastActualsMonthlyAggregation;
//     else if (section === 'pastForecast' || section === 'past_forecast') aggObj = pastForecastMonthlyAggregation;
//     else if (section === 'projected') aggObj = projectedMonthlyAggregationFinal;

//     console.log("aggObj", section, aggObj)
//     // find monthly values array for this row (if any)
//     const monthlyVals = findMonthlyArrayInAgg(aggObj, candidates); // array aligned with monthsMeta

//     for (let i = 0; i < (valuesArr?.length || 0); i++) {
//       const v = valuesArr[i];
//       // normal weekly cell
//       const cellClass = section === 'pastActuals' ? 'past_actuals_2' : (section === 'pastForecast' ? 'past_actuals_3' : 'projected');
//       cells.push(
//         <td key={`wk-${section}-${i}`} className={cellClass}>
//           {v === 0 ? '-' : (v == null ? '-' : (typeof v === 'number' ? v.toLocaleString('en-IN') : v))}
//         </td>
//       );

//       // compute global index for this week-column (0-based)
//       const globalIdx = baseGlobalIndex + i;

//       // get month index if this global index is last week-of-month (uses section-specific map when available)
//       const monthIdxRaw = getMonthIdxForGlobalWeek(section, globalIdx);
//       const monthIdx = (monthIdxRaw === undefined) ? null : monthIdxRaw;

//       console.log("month indx values", baseGlobalIndex, globalIdx, monthIdxRaw, monthIdx);

//       if (monthIdx !== null && monthIdx !== undefined) {
//         // monthly aggregated value for this row at that month index
//         const mVal = monthlyVals ? monthlyVals[monthIdx] : null;
//         cells.push(
//           <td key={`mon-${section}-${globalIdx}`} className={`${cellClass} monthly-agg`}>
//             {mVal == null || mVal === 0 ? '-' : (typeof mVal === 'number' ? mVal.toLocaleString('en-IN') : mVal)}
//           </td>
//         );
//       }
//     }

//     return cells;
//   };

//   return (
//     <>
//       <td className="columfix fixed-left style_icons " title={title}>
//         {icons && <span className='_icons' onClick={toggleIcons}>{icons}</span>} {rowData}
//       </td>

//       {/* 1. last-year months (leave as is) */}
//       {PastActualsOneValue && (
//         <PastActualsOne
//           values={monthlyValues}
//           className="past_actuals"
//         />
//       )}

//       {/* 2. this-year past weeks — render weeks + month-aggregate cells */}
//       {PastActualsTwoValue && (
//         <>
//           {renderWeekCellsWithMonthInsert(weeklyValues, 'pastActuals', 0)}
//         </>
//       )}

//       {/* 3. past forecast weeks */}
//       {PastForecastOneValue && (
//         <>
//           {renderWeekCellsWithMonthInsert(forecastValues, 'pastForecast', pastActualsCount || 0)}
//         </>
//       )}

//       {/* 4. projected weeks */}
//       {PastForecastTwoValue && (
//         <>
//           {renderWeekCellsWithMonthInsert(projectionValues, 'projected', (pastActualsCount || 0) + (forecastCount || 0))}
//         </>
//       )}

//     </>
//   );
// }
//correct

// experiment code
import React, { useContext, useMemo, useEffect } from 'react';
import PastActualsOne from './PastActualsOne';
import { AppContext } from '../../contexts/AppContext';
import { EditContext } from '../RightCompoent';
import { MAX_WEEK_NUM } from "../../config";

/* ---------- small helpers ---------- */

function normalizeKeyCandidates(rowData, inputName) {
  const candidates = [];
  if (inputName) candidates.push(String(inputName));
  if (rowData) {
    const s = String(rowData).trim();
    candidates.push(s);
    candidates.push(s.toLowerCase());
    candidates.push(s.replace(/\s+/g, '_').toLowerCase());
    candidates.push(s.replace(/\W+/g, '_').toLowerCase());
  }
  return candidates.filter(Boolean);
}

function normalizeKpiKey(s) {
  if (s == null) return '';
  return String(s).trim().toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '_');
}

function normMonthKey(m) {
  if (m == null) return null;
  if (Array.isArray(m) && m.length >= 2) return `${Number(m[0])}-${Number(m[1])}`;
  if (typeof m === 'object') {
    const y = (m.year ?? m.y ?? (m[0] != null ? m[0] : null));
    const mo = (m.month ?? m.mon ?? (m[1] != null ? m[1] : null));
    if (y != null && mo != null) return `${Number(y)}-${Number(mo)}`;
    try { return JSON.stringify(m); } catch (e) { return String(m); }
  }
  const s = String(m).trim();
  if (s.includes('-') || s.includes('/')) {
    const sep = s.includes('-') ? '-' : '/';
    const parts = s.split(sep);
    if (parts.length >= 2) {
      const y = Number(parts[0]), mo = Number(parts[1]);
      if (!Number.isNaN(y) && !Number.isNaN(mo)) return `${y}-${mo}`;
    }
  }
  return s;
}

/* find a named-array (kpis, drivers etc.) within monthly_aggregation */
function findMonthlyArrayInAgg(aggObj, candidates) {
  if (!aggObj) return null;
  const sections = ['input', 'kpis', 'drivers',
    'stock', 'stocks', 'stocks_monthly', 'stock_monthly',
    'forecast_tertiary', 'forecasted_tertiary', 'forecast_tert', 'forecast_tertiary_monthly',
    'exposure', 'inputs'];
  for (const sec of sections) {
    const arr = aggObj[sec];
    if (!Array.isArray(arr)) continue;
    for (const c of candidates) {
      const found = arr.find(it => it && it.input_name && String(it.input_name).toLowerCase() === String(c).toLowerCase());
      if (found && Array.isArray(found.val)) return found.val;
    }
  }
  if (Array.isArray(aggObj)) {
    for (const c of candidates) {
      const found = aggObj.find(it => it && it.input_name && String(it.input_name).toLowerCase() === String(c).toLowerCase());
      if (found && Array.isArray(found.val)) return found.val;
    }
  }
  // fuzzy fallback
  for (const sec of sections) {
    const arr = aggObj[sec];
    if (!Array.isArray(arr)) continue;
    for (const it of arr) {
      if (!it || !it.input_name) continue;
      for (const c of candidates) {
        if (String(it.input_name).toLowerCase().includes(String(c).toLowerCase()) ||
          String(c).toLowerCase().includes(String(it.input_name).toLowerCase())) {
          if (Array.isArray(it.val)) return it.val;
        }
      }
    }
  }
  return null;
}

/* ------------------ buildUnion (frontend fallback) ------------------
   Accepts pastAgg, forecastAgg, projectedAgg (each in your "monthly_aggregation" named-array shape),
   or backendUnion in the same shape { months: [...], kpis: [{input_name, val}] }
   Returns: { months, monthKeys, kpiMap } where kpiMap[normalizedKey] = array|null
*/
function buildUnion({ pastAgg = {}, forecastAgg = {}, projectedAgg = {}, backendUnion = null }) {
  if (backendUnion && Array.isArray(backendUnion.kpis)) {
    const months = backendUnion.months || backendUnion.month || [];
    const monthKeys = months.map(normMonthKey);
    const map = {};
    for (const e of backendUnion.kpis) {
      if (!e || !e.input_name) continue;
      map[normalizeKpiKey(e.input_name)] = Array.isArray(e.val) ? e.val.slice() : [];
    }
    return { months, monthKeys, kpiMap: map };
  }

  // helper: index a named-array monthly aggregation into {kpiKey -> {vals, monthKeys}}
  const indexAgg = (agg) => {
    const months = agg?.months || agg?.month || [];
    const monthKeys = (Array.isArray(months) ? months.map(normMonthKey) : []);
    const kpiMap = {};
    if (Array.isArray(agg?.kpis)) {
      for (const entry of agg.kpis) {
        if (!entry || entry.input_name == null) continue;
        kpiMap[normalizeKpiKey(entry.input_name)] = {
          vals: Array.isArray(entry.val) ? entry.val.slice() : [],
          monthKeys
        };
      }
    }
    return { months, monthKeys, kpiMap };
  };

  const p = indexAgg(pastAgg);
  const f = indexAgg(forecastAgg);
  const proj = indexAgg(projectedAgg);

  // union months in order: past -> forecast -> projected
  const order = [];
  const seen = new Set();
  const addMonths = (mArr) => {
    (mArr || []).forEach(m => {
      const k = normMonthKey(m);
      if (!seen.has(k)) {
        seen.add(k);
        order.push(m);
      }
    });
  };
  addMonths(p.months); addMonths(f.months); addMonths(proj.months);
  const unionMonthKeys = order.map(normMonthKey);

  const allNames = new Set([
    ...Object.keys(p.kpiMap),
    ...Object.keys(f.kpiMap),
    ...Object.keys(proj.kpiMap)
  ]);

  const unionKpiMap = {};
  for (const name of allNames) {
    // projected authoritative if it has values
    if (proj.kpiMap[name] && proj.kpiMap[name].vals.length > 0) {
      const arr = new Array(order.length).fill(null);
      for (let i = 0; i < proj.kpiMap[name].monthKeys.length; i++) {
        const mk = proj.kpiMap[name].monthKeys[i];
        const unionIdx = unionMonthKeys.indexOf(mk);
        if (unionIdx >= 0) arr[unionIdx] = proj.kpiMap[name].vals[i];
      }
      unionKpiMap[name] = arr;
      continue;
    }
    // otherwise sum across sections
    const sums = new Array(order.length).fill(0);
    let foundAny = false;
    for (const sec of [p, f, proj]) {
      const entry = sec.kpiMap[name];
      if (!entry) continue;
      for (let i = 0; i < entry.monthKeys.length; i++) {
        const mk = entry.monthKeys[i];
        const unionIdx = unionMonthKeys.indexOf(mk);
        if (unionIdx >= 0) {
          const v = entry.vals[i];
          if (v != null && v !== '') {
            const n = (typeof v === 'number') ? v : Number(v);
            if (!Number.isNaN(n)) { sums[unionIdx] += n; foundAny = true; }
          }
        }
      }
    }
    unionKpiMap[name] = foundAny ? sums : null;
  }

  return { months: order, monthKeys: unionMonthKeys, kpiMap: unionKpiMap };
}

/* helper to read a union value given candidate keys and monthKey */
function getUnionValueForMonth(union, monthKey, candidates) {
  if (!union || !Array.isArray(candidates) || !monthKey) return null;
  const normCandidates = candidates.map(s => normalizeKpiKey(String(s || '')));
  for (const c of normCandidates) {
    const arr = union.kpiMap?.[c];
    if (Array.isArray(arr)) {
      const idx = union.monthKeys.indexOf(monthKey);
      if (idx >= 0) {
        const v = arr[idx];
        if (v != null) return v;
      }
    }
  }
  return null;
}

/* ------------------------------------------------------------------ */

export default function DynamicTableRow({
  icons, rowData, title, title2, toggleIcons,
  monthlyValues = [], weeklyValues = [], forecastValues = [], projectionValues = [],
  lastWeekIndexToMonthIdx = {}, monthsMeta = [],
  lastWeekIndexToMonthIdxBySection = {},
  monthsMetaBySection = {},
  pastActualsMonthlyAggregation = {}, pastForecastMonthlyAggregation = {}, projectedMonthlyAggregation = {},
  aggregations_union_arr = null,
  inputName, pastActualsCount, forecastCount, projectionCount
}) {
  const { PastActualsOneValue, PastActualsTwoValue, PastForecastOneValue, PastForecastTwoValue } = useContext(AppContext);
  const editCtx = useContext(EditContext) || {};
  const { projectedMonthlyAggregationEdited } = editCtx;

  // final projected aggregation: edited overrides original if non-empty
  const projectedMonthlyAggregationFinal = projectedMonthlyAggregationEdited &&
    Object.keys(projectedMonthlyAggregationEdited).length > 0
    ? projectedMonthlyAggregationEdited
    : projectedMonthlyAggregation;

  // union (prefer backend-provided union if present, otherwise build from sections)
  const union = useMemo(() => buildUnion({
    pastAgg: pastActualsMonthlyAggregation || {},
    forecastAgg: pastForecastMonthlyAggregation || {},
    projectedAgg: projectedMonthlyAggregationFinal || {},
    backendUnion: aggregations_union_arr || null
  }), [pastActualsMonthlyAggregation, pastForecastMonthlyAggregation, projectedMonthlyAggregationFinal, aggregations_union_arr]);

  useEffect(() => {
    // helpful debug — remove in production
    // eslint-disable-next-line no-console
    console.log('DynamicTableRow union built:', !!union, union && { months: union.months?.length, kpis: Object.keys(union.kpiMap || {}).length });
  }, [union]);

  // helper to get month-index (existing logic, unchanged)
  const getMonthIdxForGlobalWeek = (sectionKey, globalIdx) => {
    if (globalIdx == null) return undefined;
    if (globalIdx >= MAX_WEEK_NUM) globalIdx = globalIdx - MAX_WEEK_NUM;
    const canonical =
      sectionKey === 'pastActuals' || String(sectionKey).toLowerCase().includes('actual') ? 'pastActuals' :
        sectionKey === 'pastForecast' || String(sectionKey).toLowerCase().includes('forecast') ? 'pastForecast' :
          'projected';
    const sectionMap = lastWeekIndexToMonthIdxBySection && lastWeekIndexToMonthIdxBySection[canonical];
    if (sectionMap) {
      if (typeof sectionMap.get === 'function') return sectionMap.get(globalIdx);
      return sectionMap[String(globalIdx)];
    }
    if (!lastWeekIndexToMonthIdx) return undefined;
    if (typeof lastWeekIndexToMonthIdx.get === 'function') return lastWeekIndexToMonthIdx.get(globalIdx);
    return lastWeekIndexToMonthIdx[String(globalIdx)];
  };

  // render weeks; when month-aggregate cell needed, prefer union value (if present)
  // const renderWeekCellsWithMonthInsert = (valuesArr = [], section, baseGlobalIndex = 0) => {
  //   const cells = [];
  //   let candidates;
  //   if ((section === 'pastForecast' || section === 'projected') && title2) {
  //     if (section === 'pastForecast' && rowData === "Opening Retailer Stk") candidates = normalizeKeyCandidates("opening_ret_stk", inputName);
  //     else candidates = normalizeKeyCandidates(title2, inputName);
  //   } else {
  //     candidates = normalizeKeyCandidates(title, inputName);
  //   }

  //   let aggObj = null;
  //   if (section === 'pastActuals' || section === 'past_actuals') aggObj = pastActualsMonthlyAggregation;
  //   else if (section === 'pastForecast' || section === 'past_forecast') aggObj = pastForecastMonthlyAggregation;
  //   else if (section === 'projected') aggObj = projectedMonthlyAggregationFinal;

  //   // section-level monthly array (fallback)
  //   const monthlyVals_local = findMonthlyArrayInAgg(aggObj, candidates);

  //   for (let i = 0; i < (valuesArr?.length || 0); i++) {
  //     const v = valuesArr[i];
  //     const cellClass = section === 'pastActuals' ? 'past_actuals_2' : (section === 'pastForecast' ? 'past_actuals_3' : 'projected');

  //     // week cell
  //     cells.push(
  //       <td key={`wk-${section}-${i}`} className={cellClass}>
  //         {v === 0 ? '-' : (v == null ? '-' : (typeof v === 'number' ? v.toLocaleString('en-IN') : v))}
  //       </td>
  //     );

  //     const globalIdx = Number(baseGlobalIndex || 0) + Number(i || 0);

  //     const monthIdxRaw = getMonthIdxForGlobalWeek(section, globalIdx);
  //     const monthIdx = (monthIdxRaw === undefined) ? null : monthIdxRaw;

  //     if (monthIdx !== null && monthIdx !== undefined) {
  //       // compute canonical month meta for this section for building monthKey
  //       const canonical = section === 'pastActuals' || String(section).toLowerCase().includes('actual') ? 'pastActuals' :
  //         section === 'pastForecast' || String(section).toLowerCase().includes('forecast') ? 'pastForecast' : 'projected';
  //       const monthsForThisCanonical = monthsMetaBySection && monthsMetaBySection[canonical] ? monthsMetaBySection[canonical] : monthsMeta || [];
  //       const monthMeta = monthsForThisCanonical[monthIdx];
  //       const monthKey = normMonthKey(monthMeta);

  //       // first prefer union value
  //       let displayVal = null;
  //       if (union && monthKey) {
  //         const u = getUnionValueForMonth(union, monthKey, candidates);
  //         if (u != null) displayVal = u;
  //       }

  //       // fallback to section-level monthly val if union didn't provide
  //       if (displayVal == null && monthlyVals_local) {
  //         displayVal = monthlyVals_local[monthIdx];
  //       }

  //       // final formatting
  //       const formatted = (displayVal == null || displayVal === 0) ? '-' : (typeof displayVal === 'number' ? Number(displayVal).toLocaleString('en-IN') : displayVal);

  //       cells.push(
  //         <td key={`mon-${section}-${globalIdx}`} className={`${cellClass} monthly-agg`}>
  //           {formatted}
  //         </td>
  //       );
  //     }
  //   }

  //   return cells;
  // };

  // render weeks; when month-aggregate cell needed, prefer union value (if present)
  const renderWeekCellsWithMonthInsert = (valuesArr = [], section, baseGlobalIndex = 0) => {
    const cells = [];
    let candidates;
    if ((section === 'pastForecast' || section === 'projected') && title2) {
      if (section === 'pastForecast' && rowData === "Opening Retailer Stk") {
        candidates = normalizeKeyCandidates("opening_ret_stk", inputName);
      } else {
        candidates = normalizeKeyCandidates(title2, inputName);
      }
    } else {
      candidates = normalizeKeyCandidates(title, inputName);
    }

    let aggObj = null;
    if (section === 'pastActuals' || section === 'past_actuals') aggObj = pastActualsMonthlyAggregation;
    else if (section === 'pastForecast' || section === 'past_forecast') aggObj = pastForecastMonthlyAggregation;
    else if (section === 'projected') aggObj = projectedMonthlyAggregationFinal;

    // section-level monthly array (fallback)
    const monthlyVals_local = findMonthlyArrayInAgg(aggObj, candidates);

    for (let i = 0; i < (valuesArr?.length || 0); i++) {
      const v = valuesArr[i];
      const cellClass =
        section === 'pastActuals'
          ? 'past_actuals_2'
          : section === 'pastForecast'
            ? 'past_actuals_3'
            : 'projected';

      // week cell
      cells.push(
        <td key={`wk-${section}-${i}`} className={cellClass}>
          {v === 0 ? '-' : v == null ? '-' : typeof v === 'number' ? v.toLocaleString('en-IN') : v}
        </td>
      );

      const globalIdx = Number(baseGlobalIndex || 0) + Number(i || 0);

      // find monthIdx via provided mappings
      let monthIdx = null;
      let monthMeta = null;

      const monthIdxRaw = getMonthIdxForGlobalWeek(section, globalIdx);
      if (monthIdxRaw !== undefined && monthIdxRaw !== null) {
        monthIdx = monthIdxRaw;
      } else {
        // fallback: try using lastWeekIndexToMonthIdxBySection
        const canonical =
          section === 'pastActuals' || String(section).toLowerCase().includes('actual')
            ? 'pastActuals'
            : section === 'pastForecast' || String(section).toLowerCase().includes('forecast')
              ? 'pastForecast'
              : 'projected';

        const lastWeekMap =
          lastWeekIndexToMonthIdxBySection && lastWeekIndexToMonthIdxBySection[canonical]
            ? lastWeekIndexToMonthIdxBySection[canonical]
            : {};

        const foundIdx = lastWeekMap[globalIdx];
        if (foundIdx != null) {
          monthIdx = foundIdx;
        }
      }

      if (monthIdx !== null && monthIdx !== undefined) {
        const canonical =
          section === 'pastActuals' || String(section).toLowerCase().includes('actual')
            ? 'pastActuals'
            : section === 'pastForecast' || String(section).toLowerCase().includes('forecast')
              ? 'pastForecast'
              : 'projected';

        const monthsForThisCanonical =
          monthsMetaBySection && monthsMetaBySection[canonical]
            ? monthsMetaBySection[canonical]
            : monthsMeta || [];

        monthMeta = monthsForThisCanonical[monthIdx];
        const monthKey = normMonthKey(monthMeta);

        // first prefer union value
        let displayVal = null;
        if (union && monthKey) {
          const u = getUnionValueForMonth(union, monthKey, candidates);
          if (u != null) displayVal = u;
        }

        // fallback to section-level monthly val if union didn't provide
        if (displayVal == null && monthlyVals_local) {
          displayVal = monthlyVals_local[monthIdx];
        }

        // final formatting
        const formatted =
          displayVal == null || displayVal === 0
            ? '-'
            : typeof displayVal === 'number'
              ? Number(displayVal).toLocaleString('en-IN')
              : displayVal;

        cells.push(
          <td key={`mon-${section}-${globalIdx}`} className={`${cellClass} monthly-agg`}>
            {formatted}
          </td>
        );
      }
    }

    return cells;
  };


  return (
    <>
      <td className="columfix fixed-left style_icons " title={title}>
        {icons && <span className='_icons' onClick={toggleIcons}>{icons}</span>} {rowData}
      </td>

      {/* 1. last-year months */}
      {PastActualsOneValue && <PastActualsOne values={monthlyValues} className="past_actuals" />}

      {/* 2. this-year past weeks */}
      {PastActualsTwoValue && <>{renderWeekCellsWithMonthInsert(weeklyValues, 'pastActuals', 0)}</>}

      {/* 3. past forecast weeks */}
      {PastForecastOneValue && <>{renderWeekCellsWithMonthInsert(forecastValues, 'pastForecast', Number(pastActualsCount || 0))}</>}

      {/* 4. projected weeks */}
      {PastForecastTwoValue && <>{renderWeekCellsWithMonthInsert(projectionValues, 'projected', Number(pastActualsCount || 0) + Number(forecastCount || 0))}</>}
    </>
  );
}

// experiement code [END]





